import React, { useEffect } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";

import PreviousStepBtn from "../../components/PreviousStepBtn/PreviousStepBtn";
import TipsSection from "./molecules/TipsSection";
import FlightSummary from "./organisms/FlightSummary";
import CardsForms from "./organisms/CardsForms/CardsForms";
import { billingAddress } from "../../constants/selectOptions";
import useStyles from "./styles";
import Accreditation from "../../components/Accreditation/Accreditation";

export default function Step4({
  handleBack,
  handleNext,
  selectedFlight,
  apiData,
  cards,
  tipsValue,
}) {
  const classes = useStyles();
  const { control, register, setValue, getValues, formState } =
    useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "cards",
  });

  //VALUES
  const currentValues = useWatch({ name: "cards" }) || getValues("cards");
  const manualSplitValue = useWatch({name: 'manualSplit'}) || getValues('manualSplit')
  const acceptTipsValue =
    useWatch({ name: "acceptTips" }) || getValues("acceptTips");
  const splitPaymentValue =
    useWatch({ name: "splitPayment" }) || getValues("splitPayment");
  const confirmTermsValue =
    useWatch({ name: "confirmTerms" }) || getValues("confirmTerms");
  const travelCareValue =
    useWatch({ name: "travelCare" }) || getValues("travelCare");

  const totalAmount =
    parseFloat(useWatch({ name: "totalAmount" }) || getValues("totalAmount"));

  const defaultCardValues = {
    id: null,
    cardNumber: "",
    cardHolderName: "",
    expirationDate: null,
    cvv: "",
    country: "",
    city: "",
    state: "",
    street: "",
    postalCode: "",
    cardHolderEmail: "",
    cardPhoneNumber: "",
    billingAddress: "default",
  };

  const addNewCard = () => {
    append({
      ...defaultCardValues,
      card_id: `card_${fields.length + 1}`
    });
  };

  useEffect(() => {
    if (splitPaymentValue === true && fields.length > 1) {
    } else if (splitPaymentValue === true && fields.length === 1) {
      addNewCard();
    } else if (currentValues.length > 1) {
      setValue("cards", [fields[0]]);
    }
  }, [splitPaymentValue]);

  useEffect(() => {
    if (totalAmount > 0 && cards.length === 0) {
      addNewCard();
    } else if (totalAmount === 0 && cards.length > 0) {
      for (let i = 0; i < cards.length; i++) {
        remove(i);
      }
    }
  }, [totalAmount, cards]);

  return (
    <Grid container>
      <Grid item xs={12} md={7} className={classes.mainForm}>
        <Box
          mb={2.5}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className={classes.formHeader}
        >
          <PreviousStepBtn handleBack={handleBack}/>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            className={classes.headerText}
          >
            <Typography variant="h1" align="center">
              Payment information
            </Typography>
            <Typography variant="body1" align="center">
              All transactions are secure and encrypted
            </Typography>
          </Box>
        </Box>
        <Box className={classes.cardForm}>
          <CardsForms
            fields={fields}
            currentValues={cards}
            defaultCardValues={defaultCardValues}
            addNewCard={addNewCard}
            billingAddress={billingAddress}
            splitPaymentValue={splitPaymentValue}
            remove={remove}
            setValue={setValue}
            formType={apiData.result ? 'approve' : ''}
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={5}
        className={classes.secondaryForm}
        justify="flex-start"
        alignItems="center"
      >
        <TipsSection
          operatorInfo={apiData?.operatorInfo}
          register={register}
          defaultTips={tipsValue}
          setValue={setValue}
          acceptTips={acceptTipsValue}
        />
        <FlightSummary
          classes={classes}
          user_ip={apiData?.user_ip}
          confirmTerms={confirmTermsValue}
          handleNext={handleNext}
          selectedFlight={selectedFlight}
          tipsValue={tipsValue}
          acceptTipsValue={acceptTipsValue}
          cards={currentValues}
          splitPaymentValue={splitPaymentValue}
          manualSplitValue={manualSplitValue}
          register={register}
          setValue={setValue}
          travelCare={travelCareValue}
          airports={apiData?.airports}
          formState={formState}
          cardsAmmount={apiData?.result?.cardsAmmount}
          previewMode={false}
        />

        <Box width={1}>
          <Accreditation />
        </Box>
      </Grid>
    </Grid>
  );
}
